import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function NextDeveloperPage() {
  return <FrontendDeveloperPage technology="nextjs" />;
}
